


/**
* Execution Types (flow of a session) within a GuideStream for the mentee/client
*/
export enum ExecutionType{
    /**
    * Uses the scheduling UI within Guide Stream 360
    */
    Scheduled = 0,
    /**
    * The item has a set schedule date but it is set exclusives by the API
    */
    ExternallyScheduled = 1,
    /**
    * An ad hoc item that it to be executed immediately by the contact on the GuideStream and the mentor is waiting for them to join
    */
    AdHoc = 2,
    /**
    * An internal employee is the client and will skip the welcome, privacy screen and other pleasantries
    */
    InternalCommunication = 3
}

